import { render, staticRenderFns } from "./FleetOverview.vue?vue&type=template&id=60dd3488&scoped=true&"
import script from "./FleetOverview.vue?vue&type=script&lang=js&"
export * from "./FleetOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dd3488",
  null
  
)

export default component.exports